var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__a)",
    "data-name": "title"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.625a2.813 2.813 0 1 0-2.812-2.812A2.813 2.813 0 0 0 10 10.625m2.5.625h-1.076a3.4 3.4 0 0 1-2.848 0H7.5a2.5 2.5 0 0 0-2.5 2.5v.312a.94.94 0 0 0 .938.938h8.125a.94.94 0 0 0 .937-.937v-.313a2.5 2.5 0 0 0-2.5-2.5"
  }))));
};
export default SvgUser;